export default __webpack_public_path__ + "static/media/spoiler.492195b6.png";